import React from 'react';
import { useAuth } from './AuthContext';
import ProjectSelector from './ProjectSelector';

interface RequireProjectSelectionProps {
  children: React.ReactElement;
}

const RequireProjectSelection: React.FC<RequireProjectSelectionProps> = ({ children }) => {
  const { isAuthenticated, authorization, isProjectSelectionRequired } = useAuth();

  // If user is not authenticated, let the auth check handle it
  if (!isAuthenticated) {
    return children;
  }

  // If project selection is required (either no authorization or explicit requirement), show the project selector
  if (isProjectSelectionRequired || !authorization) {
    return <ProjectSelector />;
  }

  // Project is selected, proceed with the app
  return children;
};

export default RequireProjectSelection;
